import React from "react";
import Modal from "@mui/material/Modal";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import theme from "../../../theme";
import CustomButton from "../../common/button/CustomButton";
import {
  LOCKER_INACTIVE_MODAL_MESSAGE,
  LOCKER_INACTIVE_MODAL_MESSAGE_WITH_ORDER,
} from "../../../utils/inactiveLockerPrompt";
import {
  StyledModalBody,
  StyledModalBox,
  StyledModalFooter,
  StyledModalHeader,
  StyledModalMessage,
  StyledModalTitle,
} from "./style";

export default function InactiveLockerModal({
  open,
  onClose,
  onCreateOrder,
  hasExistingOrder = false,
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <StyledModalBox>
        <StyledModalHeader>
          <StyledModalTitle>Virtual Locker Inactive</StyledModalTitle>
          <CrossIcon color={theme.palette.custom.white} onClick={onClose} />
        </StyledModalHeader>

        <StyledModalBody>
          <StyledModalMessage>
            {hasExistingOrder
              ? LOCKER_INACTIVE_MODAL_MESSAGE_WITH_ORDER
              : LOCKER_INACTIVE_MODAL_MESSAGE}
          </StyledModalMessage>
        </StyledModalBody>

        <StyledModalFooter>
          <CustomButton
            padding="10px 24px"
            fontSize={theme.typography.regular.fontSize}
            height="44px"
            btnLabel="Close"
            btntype="white"
            color={theme.palette.custom.lockerValueColor}
            fontWeight={theme.typography.fontWeight.medium}
            border={theme.borders.defaultButton}
            onClick={onClose}
          />
          {!hasExistingOrder ? (
            <CustomButton
              padding="10px 28px"
              fontSize={theme.typography.regular.fontSize}
              height="44px"
              btnLabel="Create Order"
              btntype="primary"
              color={theme.palette.custom.white}
              fontWeight={theme.typography.fontWeight.medium}
              onClick={onCreateOrder}
            />
          ) : null}
        </StyledModalFooter>
      </StyledModalBox>
    </Modal>
  );
}
